<template>
    <div class="sl-order-form__line-side" :class="'sl-order-form__line-side-' + side">
        <!-- Helper -->
        <div class="sl-order-form__line-band-wrapper">
            <div class="sl-order-form__line-band-content"></div>
        </div>

        <!-- Error Wrapper -->
        <div class="sl-order-form__line-content-wrapper">
            <!-- Field Wrapper -->
            <div class="sl-order-form__field-wrapper">
                <!-- Field -->
                <!-- "SCC" stands for "Segment Count Controls" -->
                <div class="sl-order-form__scc">
                    <div
                        v-for="(btn, i) in btnData"
                        :key="i"
                        class="sl-order-form__scc--add lsn-btn lsn-btn--padless rounded"
                        :class="{
                            'lsn-btn--primary-outline': btn.canDo,
                            'lsn-btn--gray-outline': !btn.canDo,
                            'lsn-btn--disabled': !btn.canDo,
                        }"
                        :tabindex="tabIndex"
                        @click.prevent="btn.onClick"
                        @keypress.enter="btn.onClick"
                    >
                        <mdi-icon :icon="btn.icon" class="inline-block w-4 h-4" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onUpdated, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


// ------------------------------------------------------------ COMPOSABLES

const { t } = useI18n({ useScope: 'global' });
const store = useStore();


// ------------------------------------------------------------ PROPS

const props = defineProps({
    index:
    {
        type:     Number,
        required: true,
    },

    side:
    {
        type:     String,
        required: true,
    },

    parameter:
    {
        type:    Object,
        default: () => ({}),
    },

    name:
    {
        type:     String,
        required: true,
    },

    error:
    {
        type:    String,
        default: null,
    },

    modelValue:
    {
        type:    [String, Number, Object, Boolean, Array],
        default: null,
    },
});


// ------------------------------------------------------------ REFS

// ...


// ------------------------------------------------------------ COMPUTED

const fitting = computed(() =>
{
    const c = store.state.lensOrder.fittings.current[props.side];
    return store.state.lensOrder.fittings[props.side][c];
});
const templating = computed(() => fitting.value.getPrototype().templating);

const min  = computed(() => props.parameter.min  || -Infinity);
const max  = computed(() => props.parameter.max  || Infinity);
const step = computed(() => props.parameter.step || 1);

const prev = computed(() => props.modelValue - step.value);
const next = computed(() => props.modelValue + step.value);

const canRemove = computed(() => !templating.value && prev.value >= min.value);
const canAdd    = computed(() => !templating.value && next.value <= max.value);

const tabIndex = computed(() => props.side === 'left' ? 2 : 1);

const btnData = computed(() =>
{
    const buttons = [
        {
            canDo:   canAdd.value,
            onClick: add,
            icon:    'mdiPlus',
        },
        {
            canDo:   canRemove.value,
            onClick: remove,
            icon:    'mdiMinus',
        },
    ];

    return props.side === 'right' ? buttons : buttons.reverse();
});


// ------------------------------------------------------------ EMITS

const emit = defineEmits(['update:modelValue']);


// ------------------------------------------------------------ METHODS

/**
 * Increment the model value.
 */
function add()
{
    console.log('add segment', props.parameter.code, props.modelValue, canAdd.value); // @xxx
    if(!canAdd.value)
    {
        return;
    }

    emit('update:modelValue', next.value);
}

/**
 * Decrement the model value.
 */
function remove()
{
    console.log('remove segment', props.parameter.code, props.modelValue, canRemove.value); // @xxx
    if(!canRemove.value)
    {
        return;
    }

    emit('update:modelValue', prev.value);
}


// ------------------------------------------------------------ LIFECYCLE HOOKS

// ...
</script>

<style scoped>
@reference "#main.css";

.sl-order-form__scc
{
    @apply flex items-center gap-1;
}
</style>
